import classNames from "classnames";
import { useEffect } from "react";
import { StyledTextArea, StyledTextAreaTypes } from "src/components";
import styles from "./styles.module.scss";

const classname = "auto-response";

export const AutoResponse = ({ autoResponseFormik, setFormikState, getFieldProps, autoResponse, errors, touched }) => {
    useEffect(() => {
        if (autoResponseFormik) {
            setFormikState(autoResponseFormik);
        }
    }, [autoResponseFormik]);

    return (
        <form>
            <div className={classNames(styles[classname], "profile-automations-item-wrapper")}>
                <StyledTextArea
                    autoCapitalize="none"
                    autoCorrect="none"
                    type={StyledTextAreaTypes.primaryStatic}
                    placeholder="AUTO-RESPONSE "
                    tabIndex={1}
                    rows={5}
                    isMaxLengthRequire={false}
                    value={autoResponse}
                    showErrorText={true}
                    className={"profile-automations-section-textarea"}
                    error={touched.autoResponse && errors.autoResponse}
                    {...getFieldProps("autoResponse")}
                />
                {/* <StyledDuoButtons
                className={classNames(styles[`${classname}-duo-buttons`], "duo-buttons", "profile-listing-footer")}
                firstButtonClick={onCancelClick}
                secondButtonClick={onSaveClick}
                firstButtonText="Cancel"
                secondButtonText="Save"
                secondButtonProps={{ processing: saveAutoResponseProcessing }}
                type={StyledDuoButtonsTypes.primary}
            /> */}
            </div>
        </form>
    );
};
